import {Tooltip} from '@mantine/core';
import React from 'react';
import toBrl from 'shared/util/to-brl';
import styled, {useTheme} from 'styled-components';

interface Props {
  label: string;
  value: number;
  variant?: 'green' | 'red';
  tooltip: string;
}

const BillingSection: React.FC<Props> = ({label, value, variant, tooltip}) => {
  const {colors} = useTheme();
  return (
    <Row style={{justifyContent: 'space-between'}}>
      <Text>{label}</Text>
      <Tooltip label={tooltip} multiline styles={{tooltip: {width: 200}}}>
        <Text
          style={{
            cursor: 'pointer',
            fontWeight: variant ? '600' : undefined,
            color:
              variant === 'green'
                ? colors.success
                : variant === 'red'
                ? colors.red
                : undefined,
          }}>
          {toBrl(value)}
        </Text>
      </Tooltip>
    </Row>
  );
};

export default BillingSection;

const Text = styled.text`
  color: ${(props) => props.theme.colors.text};
  font-weight: 300;
  line-height: normal;
`;

const Row = styled.div`
  display: flex;
`;
